import { render, staticRenderFns } from "./TabGripStrength.vue?vue&type=template&id=6091708c&scoped=true&"
import script from "./TabGripStrength.vue?vue&type=script&lang=js&"
export * from "./TabGripStrength.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6091708c",
  null
  
)

export default component.exports